import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {
  heading: 'heading',
  body_text: 'body_text',
  media_image: 'media_image',
  spec_table: 'spec_table',
  columns_1: 'columns_1',
  columns_2: 'columns_2',
  columns_3: 'columns_3',
  columns_4: 'columns_4',
  cta: 'cta',
  rating_badge: 'rating_badge',
  stat_group: 'stat_group',
  comparison_table: 'comparison_table',
  media_video: 'media_video',
  list_item: 'list_item',
  icon_grid: 'icon_grid',
};

export default {
  crawlType: 'side_by_side',
  [IDENTIFIER_TAGS.comparison_table]: [
    {
      type: sectionType.sectionCardWithTableCompare,
      tags: [IDENTIFIER_TAGS.heading, IDENTIFIER_TAGS.body_text, IDENTIFIER_TAGS.comparison_table],
      priority: 1,
    },
  ],
  [IDENTIFIER_TAGS.media_video]: [
    {
      type: sectionType.sectionCardVideo,
      tags: [IDENTIFIER_TAGS.heading, IDENTIFIER_TAGS.body_text, IDENTIFIER_TAGS.media_video],
      priority: 1,
    },
  ],
  matchTemplates: [
    {
      type: sectionType.sectionCustomizeCard,
      tags: [
        IDENTIFIER_TAGS['cta'],
        IDENTIFIER_TAGS['rating_badge'],
        IDENTIFIER_TAGS.heading,
        IDENTIFIER_TAGS.body_text,
        IDENTIFIER_TAGS.media_image,
      ],
      priority: 1,
    },
    {
      type: sectionType.sectionCardSmoking,
      tags: [IDENTIFIER_TAGS.heading, IDENTIFIER_TAGS.body_text, IDENTIFIER_TAGS.media_image],
      priority: 2,
    },
    {
      type: sectionType.sectionCardBasicRivoneed,
      tags: [
        IDENTIFIER_TAGS.heading,
        IDENTIFIER_TAGS.body_text,
        IDENTIFIER_TAGS.media_image,
        IDENTIFIER_TAGS.spec_table,
      ],
      priority: 3,
    },
    {
      type: sectionType.sectionCardWithSurvey,
      tags: [
        IDENTIFIER_TAGS.heading,
        IDENTIFIER_TAGS.body_text,
        IDENTIFIER_TAGS.media_image,
        IDENTIFIER_TAGS.stat_group,
      ],
      priority: 4,
    },
    {
      type: sectionType.sectionSatelliteGrid,
      tags: [
        IDENTIFIER_TAGS.heading,
        IDENTIFIER_TAGS.body_text,
        IDENTIFIER_TAGS.media_image,
        IDENTIFIER_TAGS.list_item,
        IDENTIFIER_TAGS.icon_grid,
        IDENTIFIER_TAGS.columns_4,
      ],
      priority: 7,
    },
    {
      type: sectionType.sectionImageWithTextCol1,
      tags: [
        IDENTIFIER_TAGS.heading,
        IDENTIFIER_TAGS.body_text,
        IDENTIFIER_TAGS.media_image,
        IDENTIFIER_TAGS.columns_1,
      ],
      priority: 8,
    },
    {
      type: sectionType.sectionFaqCard,
      tags: [
        IDENTIFIER_TAGS.heading,
        IDENTIFIER_TAGS.body_text,
        IDENTIFIER_TAGS.media_image,
        IDENTIFIER_TAGS.icon_grid,
      ],
      priority: 9,
    },
  ],
};
